import SelectedbarStore from './SelectedBarStore'
import { transport, sessionStorage, flashMessage } from '../../../../lib/services'
import { eventBus } from '../../../../lib/utils/dom'

export default new SelectedbarStore({ transport, sessionStorage, flashMessage, eventBus })
